import { useEffect, useState } from "react";
import "../../App.css"; // for fonts
import Footer from "../Footer/Footer";
import {
  VStack,
  Heading,
  useColorModeValue,
  Spacer,
  Box,
} from "@chakra-ui/react";
import StarryBackground from "../StarryBackground/StarryBackground";
import ThemeColorSetter from "../ThemeColorSetter/ThemeColorSetter";
import WarGame from "../WarGame/WarGame";
import SunsetAngle from "../SunsetAngle/SunsetAngle";
import TravelMap from "../TravelMap/TravelMap";
// import Game from "../Game/Game";

export default function HomePage() {
  const textColor = useColorModeValue("#4b635e", "#E9A6A6");
  const [showSunsetAngle, setShowSunsetAngle] = useState(false);
  const [showWar, setShowWar] = useState(false);
  const [showMap, setShowMap] = useState(false);

  // set the view height variable for CSS using view height (solves iPhone problem)
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVH();
    window.addEventListener("resize", setVH);
    return () => window.removeEventListener("resize", setVH);
  }, []);

  return (
    <VStack
      minH="calc(var(--vh, 1vh) * 99.5)"
      maxH="calc(var(--vh, 1vh) * 99.5)"
      position="relative"
      spacing="0px"
      justify="space-between"
    >
      <StarryBackground />
      <ThemeColorSetter />

      {/* Content grows to fill available space */}
      <VStack justify="start" align="center" flex="1" overflowY="auto" w="100%">
        <Spacer maxH="7vh" />
        <Heading
          size="xl"
          color={textColor}
          textAlign="center"
          fontFamily="Lobster Two"
        >
          For Kellyan, with love
        </Heading>
        <Spacer maxH="7vh" />
        {showSunsetAngle && <SunsetAngle />}

        {showWar && <WarGame />}

        {showMap && <TravelMap />}

        {/* <Game /> */}
      </VStack>

      {/* Footer naturally fits content */}
      <Box w="100%">
        <Footer
          showSunsetAngle={showSunsetAngle}
          setShowSunsetAngle={setShowSunsetAngle}
          showWar={showWar}
          setShowWar={setShowWar}
          showMap={showMap}
          setShowMap={setShowMap}
        />
      </Box>
    </VStack>
  );
}
